import API from 'services/API';
import { OwnerAccount } from 'models/OwnerAccount';
import { PropertyOwnerPermissionType } from 'models/Owner';
import useAppUser from './useAppUser';
import useAppQuery from './useAppQuery';

const useAnalytics = () => {
  const { userUid, isOwner } = useAppUser();

  const { data: ownerAccount } = useAppQuery(
    ['getOwnerAccount'],
    async () => {
      const response = await API.get<{ owner: OwnerAccount }>(
        `v3/owners/${userUid}`,
      );
      return response.data.owner;
    },
    {
      enabled: isOwner && !!userUid,
    },
  );

  const hasViewAnalyticsPermission = ownerAccount?.permissionTypes?.includes(
    PropertyOwnerPermissionType.VIEW_ANALYTICS,
  );
  const showOwnerAnalytics = !isOwner || hasViewAnalyticsPermission;
  return showOwnerAnalytics;
};

export default useAnalytics;
